import { CheckboxProps } from '@mui/material';
import { useEffect, useRef } from 'react';
export default function Checkbox({checked, defaultChecked, disabled, indeterminate, onChange, inputProps, id, name, value, className, required, ...rest}: CheckboxProps) {
    const ref=useRef<HTMLInputElement>(null);
    useEffect(()=>{if(ref.current)ref.current.indeterminate=!!indeterminate;},[indeterminate]);
    return <input {...inputProps} ref={ref} id={id} type="checkbox" name={name} value={value as any}
        className={`form-check-input form-check-input-custom ${className || ''}`} checked={checked} defaultChecked={defaultChecked}
        disabled={disabled} required={required} aria-checked={indeterminate ? 'mixed' : checked} aria-label={inputProps?.['aria-label'] || rest['aria-label'] || name || 'Chọn bản ghi'}
        onChange={event=>onChange?.(event,event.target.checked)}/>;
}
